import { render, staticRenderFns } from "./DirectSchoolLocation.vue?vue&type=template&id=ea6ec448&scoped=true&"
import script from "./DirectSchoolLocation.vue?vue&type=script&lang=js&"
export * from "./DirectSchoolLocation.vue?vue&type=script&lang=js&"
import style0 from "./DirectSchoolLocation.vue?vue&type=style&index=0&id=ea6ec448&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea6ec448",
  null
  
)

export default component.exports